import React from "react";

import styled from "styled-components";

import { AutomationCommandProps } from "../types/automation";
import { WellListTopicPayload } from "../types/payloads";

const WellList: React.FC<AutomationCommandProps> = (props) => {
  const payload = props.command.payload as WellListTopicPayload;
  return (
    <WellListContainer>
      Well List ({payload.loopType == "Group" ? "Group" : "For each uwids"} (
      {payload.uwids.length}))
    </WellListContainer>
  );
};

export default WellList;

const WellListContainer = styled.div``;
